module.exports = __webpack_public_path__ + "img/light-green-t-shirt.cda6caa2.jpg";